import { gsap, ScrollTrigger } from './gsap';

export const revealUp = (el, trigger) => {
  gsap.set(el, { yPercent: 100, visibility: 'hidden' });
  const defaults = { ease: 'expo.out', duration: 2, overwrite: true };
  const st = ScrollTrigger.create({
    trigger,
    start: 'top 90%',
    onEnter: () => gsap.to(el, {
      ...defaults, yPercent: 0, visibility: 'visible', stagger: 0.15
    }),
    onLeave: () => gsap.to(el, { ...defaults, yPercent: -100, visibility: 'hidden' }),
    onEnterBack: () => gsap.to(el, {
      ...defaults, yPercent: 0, visibility: 'visible', stagger: 0.15
    }),
    onLeaveBack: () => gsap.to(el, { ...defaults, yPercent: 100, visibility: 'hidden' })
  });

  return st;
};
